(() => {
  // Dependency-free delegated controls can run before deferred Shopify/app scripts.
  // Delegation also survives section replacement in the Theme Editor.
  if (window.__lavienCollagenUI) return;
  window.__lavienCollagenUI = true;

  const markRoots = (scope = document) => {
    if (scope.matches?.('[data-collagen-section]')) scope.dataset.ready = 'true';
    scope.querySelectorAll('[data-collagen-section]').forEach(root => {
      root.dataset.ready = 'true';
    });
  };
  const hydrate = view => {
    const template = view?.querySelector('template[data-gallery-image]');
    if (template) template.replaceWith(template.content.cloneNode(true));
  };

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const root = event.target.closest('[data-collagen-section]');
    if (!root) return;
    const q = selector => root.querySelector(selector);
    const all = selector => root.querySelectorAll(selector);
    const galleryButton = event.target.closest('[data-gallery]');
    if (galleryButton) {
      const index = galleryButton.dataset.gallery;
      const views = all('.gallery [data-gallery-view]');
      views.forEach(view => {
        view.hidden = view.dataset.galleryView !== index;
        if (!view.hidden) hydrate(view);
      });
      all('[data-gallery]').forEach(button => {
        button.setAttribute('aria-pressed', String(button === galleryButton));
      });
      const counter = q('.gallery-heading .eyebrow:last-child');
      if (counter) counter.textContent = String(Number(index) + 1).padStart(2, '0')
        + ' / ' + String(all('[data-gallery]').length).padStart(2, '0');
      const caption = q('#gallery-caption');
      if (caption) caption.textContent = index === '0'
        ? caption.dataset.setCaption : galleryButton.textContent;
      return;
    }

    const modeButton = event.target.closest('[data-mode]');
    if (modeButton) {
      all('[data-mode]').forEach(button => {
        button.setAttribute('aria-pressed', String(button === modeButton));
      });
      all('.mode-panel').forEach(panel => {
        panel.hidden = panel.id !== modeButton.dataset.mode + '-panel';
      });
      return;
    }

    const dialog = q('#image-dialog');
    if (!dialog) return;
    if (event.target.closest('#gallery-open, #zoom')) {
      const view = q('.gallery [data-gallery-view]:not([hidden])');
      if (!view) return;
      hydrate(view);
      q('#dialog-visual').replaceChildren(view.cloneNode(true));
      if (!dialog.open) dialog.showModal();
    } else if (event.target.closest('.dialog-close') || event.target === dialog) {
      dialog.close();
    }
  });

  document.addEventListener('change', event => {
    const selector = event.target;
    if (!(selector instanceof Element) || !selector.matches('[data-collagen-variant]')) return;
    const root = selector.closest('[data-collagen-section]');
    if (!root) return;
    const q = value => root.querySelector(value);
    const variants = JSON.parse(q('[data-collagen-variants]').textContent);
    const labels = JSON.parse(q('[data-collagen-labels]').textContent);
    const variant = variants.find(v => String(v.id) === selector.value);
    if (!variant) return;
    q('[name=id]').value = variant.id;
    q('[data-collagen-price]').textContent = variant.price;
    q('[data-collagen-add]').disabled = !variant.available;
    q('[data-collagen-add]>span').textContent = variant.available ? labels.add : labels.sold;
    q('.stock-note').textContent = variant.available ? labels.shipping : labels.stock;
  });

  markRoots();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => markRoots(), { once: true });
  }
  document.addEventListener('shopify:section:load', event => markRoots(event.target));
  document.addEventListener('shopify:block:select', event => {
    const detail = event.target.closest('.lv-collagen details');
    if (detail) detail.open = true;
  });
  // Browser-local timing only. No tracking request or personal data.
  if (window.performance?.mark) performance.mark('lv-collagen-controls-ready');
})();
